<template lang="pug"> 
  dialog-format(
    v-model='dialog'
    :title="$t('description')"
    :submitstatus='submitstatus'
    @addRow='addRow'
    @submit='saveEdit'
  )
    v-form(ref="form" @submit.prevent) 
      v-row
        v-col(cols=12)
          h4 {{ $t('label.template-number-name') }}
          n-text-field-no-space.pt-2(
            v-model='nameSetEdit'
            :placeholder="$t('placeholder.template-number')"
            :rules="templateNumberNameRules"
          ) 
      template(
        v-for='(item,i) in items'
      )
        v-row(
          :key='i'
        )
          v-col
            b {{ $t('set-number-group') }} {{ i+1 }}
          v-col.text-end
            a.red--text(@click='removeRow(i)') {{ $t('remove') }}
        v-row 
          v-col(cols=4)  {{ $t('set-number') }}
          v-col(align="end" cols=8)
            v-select(
              v-model='item.number_type'
              dense
              outlined
              return-object
              item-text='name'
              hide-details="auto"
              :items='numberType'
              :rules="templateNumberTypeRules"
              :label="$t('label.select-number')"
              @change='resetValue(i)'
            )
        v-row
          v-col {{ $t('enter-number') }}
          v-col(align="end" cols=8)
            n-number-field-specific(
              v-model='item.number'
              hide-details="auto"
              :label="$t('label.number')"
              :rules='templateNumberValueRules'
              @keydown='checkLimitNumber($event,i)'
            )

</template>
<script> 
import { numberTemplate as apiNumberTemplate } from '@/apis'  
import DialogFormat from './dialogFormat'
import validate from '@/mixins/Validations'

export default { 
  components:{
    DialogFormat
  }, 
  mixins: [validate],
  data () {
    return { 
      dialog: false,  
      nameSetEdit:null,
      items:[], 
      item : [],
      uuid : null, 
      submitstatus:false
    }
  }, 
  computed : {
    numberType () { 
      return this.$store.getters['templateNumberType/GETTERS_TEMPLATENUMBER_TYPE']
    }
  }, 
  methods : {  
    async loadNumberType () {
      await this.$store.dispatch('templateNumberType/ACTION_TEMPLATENUMBER_TYPE')
    },

    checkLimitNumber (evt,index) {
      if(!this.items[index]) return

      if(!this.items[index].number_type.id 
      ||this.items[index].number.length>=this.items[index].number_type.digit
      || evt.key === '-'
      ){ 
        if (evt.keyCode !== 8 && evt.keyCode !==46 ) { 
          evt.preventDefault()
          return
        }
      }  
    }, 

    resetValue (value){   
      this.items[value].number = null  
    },

    async open (item){
      this.uuid = item.uuid
      this.nameSetEdit = item.name
      this.items = item.numbers
      this.dialog = true
      await this.loadNumberType()
    },

    addRow (){ 
      this.items.push( {
      number:null,
      number_type : {
        id: null,
        name: null,
        digit: null
      }}); 
    },
    removeRow (index){
      this.$ga.event('Button', 'RemoveStakeListOnCreate', 'TemplateNumberPage','' )
      this.items.splice(index,1);
    },
    
    async saveEdit (){
      this.$ga.event('Submit', 'UpdateTemplateNumber', 'TemplateNumberPage','' )
      if (this.$refs.form.validate()) {  

        let numbers = this.items.map(element=>{
          return {
            number:element.number,
            number_type_id :element.number_type.id
          }
        }) 

        let params = {
          name:this.nameSetEdit,
          numbers:numbers
        }

        this.submitstatus = true
        const [err, , message] = await apiNumberTemplate.update(this.uuid,params)
        this.submitstatus = false

        if(err){
          this.$alert('',err,'warning') 
          return
        }
          
        this.dialog = false 
        this.$refs.form.reset()
        this.$refs.form.resetValidation() 
        this.$alert('',message,'success')  
        this.$emit('submit') 
      } 
    },
  }
}
</script> 